module.exports = __webpack_public_path__ + "img/8aafafd0a28d35331fcb08f2e7b61a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo6.png
// module id = 914
// module chunks = 5